import { metricNames } from '@linearb/linjs-common';
import React from 'react';
import { GRAPH_TYPES } from '../consts/graphTypes';
import EmptyStateReportedWidget from '../CustomWidget/EmptyStates/EmptyStateReportedMetricsWidget/EmptyStateReportedWidget';
import useCustomWidget from '../CustomWidget/useCustomWidget';

const useReportedCustomWidget = ({
  graph,
  filters,
  widgetMetrics,
  editConfig
}) => {
  const defaultCustomWidgetProps = useCustomWidget({
    graph,
    filters,
    widgetMetrics
  });

  const { headerProps, loadingMetrics, EmptyState, graphProps } =
    defaultCustomWidgetProps;

  const isEmptyStateMetric = widgetMetrics.name === metricNames.REPORTED_CUSTOM;

  let reportedEmptyState = EmptyState;

  if (isEmptyStateMetric && !loadingMetrics) {
    reportedEmptyState = (
      <EmptyStateReportedWidget widget={graph} {...editConfig} />
    );
  }
  return {
    ...defaultCustomWidgetProps,
    headerProps: {
      ...headerProps,
      isReportedMetric: true,
      showHelp: false
    },
    graphProps: {
      ...graphProps,
      [GRAPH_TYPES.BAR]: {
        ...graphProps[GRAPH_TYPES.BAR],
        isReportedMetric: true,
        widgetFilters: graph.filters
      }
    },
    isEmptyStateMetric,
    EmptyState: reportedEmptyState
  };
};

export default useReportedCustomWidget;
